/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 */

/**
 * @module bulb-progress/bulb-upload/bulbcancelupload
 */

import { Plugin, type ModelWriter } from 'ckeditor5';

/**
 * Plugin that allows the user to cancel an upload. It uses our angular upload-asset service.
 */
export default class BulbCancelUpload extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbCancelUpload' as const;
  }

  /**
   * @inheritDoc
   */
  public init(): void {
    const { editor } = this;
    const { model } = editor;

    // Window event listener for canceling the current uploading asset:
    window.addEventListener('cancelUploadBlock', () => {
      const selectedBlock = model.document.selection.getSelectedElement();
      CKEBulbData.service.uploadAsset.cancelUpload();
      // Now remove failed upload block:
      model.change((writer: ModelWriter) => {
        writer.remove(selectedBlock);
      });
    });
  }
}
